
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="min-h-screen flex items-center justify-center relative overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.8)), url('https://public.readdy.ai/ai/img_res/08dd8fe2e4c3b7e74ce3fc3582281b99.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="container mx-auto px-6 text-center relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center px-4 py-2 bg-blue-600/20 border border-blue-500/30 rounded-full text-blue-300 text-sm mb-8">
            <i className="ri-ai-generate mr-2"></i>
            Inteligência Artificial Avançada
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Transforme sua Prospecção com IA
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed">
            Utilizamos as mais avançadas tecnologias de Inteligência Artificial e Automação 
            para tornar seus processos de vendas muito mais eficazes
          </p>

          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-blue-400 mb-2">300%</div>
              <div className="text-gray-300">Aumento em Leads Qualificados</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-purple-400 mb-2">85%</div>
              <div className="text-gray-300">Redução no Tempo de Prospecção</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-green-400 mb-2">24/7</div>
              <div className="text-gray-300">Automação Inteligente</div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <Button 
              onClick={scrollToContact}
              variant="primary" 
              size="lg"
              icon={<i className="ri-rocket-line"></i>}
              className="px-4 sm:px-6 py-3 text-sm sm:text-base text-center leading-tight"
            >
              <span className="block sm:hidden">Acelere suas Vendas com IA</span>
              <span className="hidden sm:block">Acelere suas Vendas, fale com nossa IA e veja como transformar sua Prospecção</span>
            </Button>
          </div>

          {/* Canais de Prospecção */}
          <div className="mt-8">
            <h3 className="text-2xl font-bold text-white mb-6">Nossos Canais de Prospecção</h3>
            <div className="flex flex-wrap justify-center items-center gap-8 opacity-80">
              <div className="flex items-center space-x-2 text-gray-300 hover:text-blue-400 transition-colors">
                <i className="ri-mail-line text-2xl"></i>
                <span>IA E-mail</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-300 hover:text-purple-400 transition-colors">
                <i className="ri-global-line text-2xl"></i>
                <span>IA de Voz para Site</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-300 hover:text-green-400 transition-colors">
                <i className="ri-phone-line text-2xl"></i>
                <span>IA de Voz para Telefonia</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-300 hover:text-cyan-400 transition-colors">
                <i className="ri-whatsapp-line text-2xl"></i>
                <span>IA de WhatsApp</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-300 hover:text-pink-400 transition-colors">
                <i className="ri-instagram-line text-2xl"></i>
                <span>IA de Redes Sociais</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-300 hover:text-orange-400 transition-colors">
                <i className="ri-megaphone-line text-2xl"></i>
                <span>IA de Marketing</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Elements */}
      <div className="absolute top-20 left-10 w-20 h-20 bg-blue-500/10 rounded-full blur-xl animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-32 h-32 bg-purple-500/10 rounded-full blur-xl animate-pulse delay-1000"></div>
      <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-green-500/10 rounded-full blur-xl animate-pulse delay-500"></div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
}
